import { styled } from "@mui/material";

export const NavbarContainer = styled("div")(({ theme }) => ({
  maxHeight: "calc(100vh - 40px)",
  "& .MuiList-root": {
    backgroundColor: "#1f1f1f",
    color: "#ffffff",
  },
  "& .MuiListItem-root": {
    margin: "0 auto 10px",
    cursor: "pointer",
    padding: "8px",
    color: "#ffffff",
    borderRadius: "8px",
    "& .MuiListItemIcon-root": {
      "& svg": {
        color: "#00000",
        fontSize: "1.5em",
        path: {
          stroke: "#ffffff",
        },
      },
    },
  },
  "& .MuiListItemText-root": {
    margin: "0px",
    "& .MuiTypography-root": {
      color: "#000000",
      fontSize: "1em",
      fontWeight: "400",
      lineHeight: "18.17px",
    },
  },
}));
// export default { NavbarContainer };
